import React, {useState} from 'react';
import eye from "../assets/img/eye.svg";
import eyeClouse from "../assets/img/eye-clouse.svg";
import Button from '../components/Button/Button.js';
import {word} from '../word.js'
import {useNavigate} from "react-router-dom";
import Api from "../Api.js";
import Cookies from "js-cookie"

import {toast} from "react-toastify";
import {loginAction, managerProfileRequest} from "../store/actions/manager.js";
import {useDispatch} from "react-redux";
import Account from "../helpers/Account.js";
import ResetPass from "../components/ResetPass.js";

function Login() {
    const [form, setForm] = useState([
        {key: "username", value: "", errorMessage: "email_error", type: "email", valid: false},
        {key: "password", value: "", errorMessage: "password_error", type: "password", valid: false}
    ]);
    const [prof, setProf] = useState('');
    const [reset, setReset] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const successNotify = () => toast.success(word.success_process,  { position: "top-center",theme: "colored", });
    const errorNotify = () => toast.error(word.error_process,  { position: "top-center",theme: "colored", });


    const handleKeyPress = async (e) => {
        if (e.key === "Enter") await login();
    };

    const handleInputChange = (index, value) => {
        const updatedForm = [...form];
        updatedForm[index].value = value;

        if (updatedForm[index].key === "username") {
            updatedForm[index].valid = /^[\w.%+-]+@[\w-]+\.[\w]{2,}$/i.test(value);
        } else if (updatedForm[index].key === "password") {
            updatedForm[index].valid = value.length >= 6;
        }

        setForm(updatedForm);
    };

    const togglePasswordVisibility = (index) => {
        const updatedForm = [...form];
        updatedForm[index].type = updatedForm[index].type === "text" ? "password" : "text";
        setForm(updatedForm);
    };

    const login = async () => {
      try {
          const profession = prof || "manager";
          localStorage.setItem("profession", profession)
          let data_form = {};
          setSubmitted(true);
          setDisabled(true);

          for (const field of form) {
              if (!field.valid) {
                  setDisabled(false);
                  return;
              }
              data_form[field.key] = field.value;
          }
          const {data} = await Api.login(data_form,profession)
          localStorage.setItem('token',data.token)
          dispatch(loginAction(data.token))
          await dispatch(managerProfileRequest({prof:profession,id:Cookies.get('id')}))

          successNotify()
          if(profession === 'accountant'){
              navigate('/main_employee/tasks')
              window.location.reload()
          }else if(profession === 'agent'){
            if(localStorage.getItem("in_view")){
                navigate(localStorage.getItem("in_view"))
            }
            navigate('/main_employee/agent-task')
            window.location.reload()
          }else{
              navigate('/main_employee/staff')
              window.location.reload()

          }
      }catch (e) {
          errorNotify()
          setDisabled(false);

          Account.logoutAdmin()
      }
    };

    return (
        <div className="manager-container">
            <div className='manager-login d-flex'>
                <div className="login-input-cont">
                    <div className="manager-login-input">
                        {form.map((item, index) => (
                            <div key={index} className="login-input-valid">
                                <input
                                    className="login-input"
                                    type={item.type}
                                    placeholder={word[item.key]}
                                    value={item.value}
                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                    onKeyDown={handleKeyPress}
                                    autoComplete="off"
                                />
                                {item.key === "password" && (
                                    <img src={item.type !== "text" ? eye : eyeClouse}
                                         onClick={() => togglePasswordVisibility(index)} alt=""/>
                                )}
                                {!item.valid && submitted &&
                                <div className='validation-accountant'>{word[item.errorMessage]}</div>}
                            </div>
                        ))}
                        <div>
                            <label className="cont">
                                <span className="checkmark-text">{word.login_accountant}</span>
                                <input type="checkbox" checked={prof === 'accountant'} onChange={() => setProf(prev => prev && prev === "accountant"?"":"accountant")}/>
                                <span className="checkmark"/>
                            </label>
                            <label className="cont">
                                <span className="checkmark-text">{word.login_agent}</span>
                                <input type="checkbox" checked={prof==="agent"} onChange={() => setProf(prev => prev && prev === "agent"?"":"agent")}/>
                                <span className="checkmark"/>
                            </label>

                            <p className="cont p-0">
                                <span className="checkmark-text" onClick={() =>setReset(true)}>Մոռացել եմ գաղտնաբառս</span>
                            </p>
                        </div>

                        <Button
                            disabled={disabled}
                            buttonStyle={!disabled ? "blue-button" : "blue-button blue-button-disabled"}
                            title={word.log_in}
                            onChangeValue={login}
                        />
                    </div>
                </div>
                <div className="manager-img"/>
                {reset?<ResetPass open={reset} setOpen={setReset} />:null}
            </div>
        </div>
    );
}

export default Login;